export default {"src":"/_next/static/media/unMessage.a52e0b13.svg","height":320,"width":321,"blurWidth":0,"blurHeight":0};